'use client'

import { useRef } from 'react'
import { useTrackElementInteracted, useTrackElementViewed } from '@nwwp/segment-analytics'

type TrackedLinkProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & {
  href: string
  segmentElement?: string
  segmentAttributes?: Record<string, unknown>
}

export const TrackedLink = ({
  href,
  target,
  rel,
  children,
  segmentElement,
  segmentAttributes,
  onClick,
  ...props
}: TrackedLinkProps) => {
  const trackElementInteracted = useTrackElementInteracted()
  const linkRef = useRef<HTMLAnchorElement>(null)
  const element = segmentElement ?? 'TrackedLink'
  const viewEventId = useTrackElementViewed(linkRef, { element, href, ...segmentAttributes })

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    void trackElementInteracted({
      element,
      href,
      ...segmentAttributes,
      parentEventId: viewEventId.current ?? undefined,
    })

    onClick?.(event)
  }

  return (
    <a
      ref={linkRef}
      href={href}
      target={target}
      rel={target === '_blank' ? `noopener noreferrer${rel ? ` ${rel}` : ''}` : rel}
      onClick={handleClick}
      {...props}
    >
      {children}
    </a>
  )
}
